import React from 'react';
import PropTypes from 'prop-types';
import {
  Box,
  Image,
  useTheme,
  Text,
  Button,
  GridItem,
  useDisclosure,
} from '@chakra-ui/react';

import { useUiComponentsInternationalContext } from '@repo/static-translations';

import { DeptGrid } from '../../design-system';
import NewsletterModal from './NewsletterModal';

function Newsletter({ newsletter }) {
  const theme = useTheme();
  const { tt } = useUiComponentsInternationalContext();

  const { isOpen = true, onOpen, onClose } = useDisclosure();
  const openModal = e => {
    e.preventDefault();
    e.stopPropagation();
    onOpen(e);
  };

  if (!newsletter) {
    // eslint-disable-next-line no-param-reassign
    newsletter = {
      newsletterTitle: tt(s => s.newsLetterComponent.newsletterHeader),
      newsletterDescription: tt(
        s => s.newsLetterComponent.newsletterDescription
      ),
    };
  }

  return (
    <>
      <DeptGrid>
        <GridItem colSpan={12}>
          <Box>
            <Image src={theme.images.logoV2} pb={6} alt="PetSafe Logo" />
            <Text textStyle="h4_5_6">{newsletter?.newsletterTitle}</Text>
            <Text pb={6}> {newsletter?.newsletterDescription}</Text>
            <Button variant="secondary" onClick={openModal}>
              {tt(s => s.newsLetterComponent.signUpNowButton)}
            </Button>
          </Box>
        </GridItem>
      </DeptGrid>
      <NewsletterModal isOpen={isOpen} onClose={onClose} />
    </>
  );
}

Newsletter.defaultProps = {
  newsletter: null,
};

Newsletter.propTypes = {
  newsletter: PropTypes.shape({
    newsletterTitle: PropTypes.string,
    newsletterDescription: PropTypes.string,
  }),
};

export default Newsletter;
